import React from 'react';

import { Button } from '@thinkific/chalk/Button';
import { CaretLeft } from '@thinkific/chalk/react-icons';

interface BreadcrumbProps {
  pageTitle: string;
  url: string;
  onClick: (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
}

export const Breadcrumb = ({ url, onClick, pageTitle }: BreadcrumbProps) => {
  return (
    <Button
      aria-label="Go back"
      emphasis="lowCompact"
      href={url}
      icon={CaretLeft}
      iconPosition="lead"
      hiddenLabel
      onClick={onClick}
    >
      {pageTitle}
    </Button>
  );
};

export default Breadcrumb;
